export default __webpack_public_path__ + "static/media/sneha.5f2cb537.jpg";